import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Plan from './Plan';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../style/constants';
import { Link } from 'gatsby';
import InnerLinkButton from '../../components/svgs/buttons/InnerLinkButton';

const useStyles = makeStyles((theme) => ({
  plans: {
    margin: '45px 0',
    '& > :nth-child(1)': {
      '& ul > li::before': { background: colors.ATT_BLUE },
      '& > div > :nth-child(1)': { background: colors.ATT_BLUE },
      '& > div': { borderColor: colors.ATT_BLUE },
      '& > svg': {
        transform: 'rotate(-15deg)',
        top: -55,
        left: -25,
        '&.active': {
          transform: 'rotate(-15deg) translate(-20px, -10px)',
        },
      },
    },

    '& > :nth-child(2)': {
      '& ul > li::before': { background: colors.TURQUOISE },
      '& > div > :nth-child(1)': { background: colors.TURQUOISE },
      '& > div': { borderColor: colors.TURQUOISE },
      '& > svg': {
        transform: 'rotate(-5deg)',
        top: -65,
        left: -10,
        '&.active': {
          transform: 'rotate(-5deg) translateY(-10px)',
        },
      },
    },

    '& > :nth-child(3)': {
      '& ul > li::before': { background: colors.LIGHT_BLUE },
      '& > div > :nth-child(1)': { background: colors.LIGHT_BLUE },
      '& > div': { borderColor: colors.LIGHT_BLUE },
      '& > svg': {
        transform: 'scaleX(-1) rotate(-12deg)',
        top: -60,
        left: -25,
        '&.active': {
          transform: 'scaleX(-1) rotate(-12deg) translate(-10px, -10px)',
        },
      },
    },
  },
}));

const Pricing = (props) => {
  const classes = useStyles();

  const features = [
    {
      node: {
        name: props.lang === 'en-CA' ? 'Digital signage licence' : 'Licence affichage dynamique',
        inclusions: props.lang === 'en-CA'
          ? ['1 digital signage licence']
          : ['1 licence affichage dynamique'],
        priceType: 'single',
        price: 34,
        subLabel: props.lang === 'en-CA' ? 'per month' : '/mois',
      },
    },
    {
      node: {
        name: props.lang === 'en-CA' ? 'SMS module (average)' : 'Module textos moyen',
        inclusions: props.lang === 'en-CA'
          ? ['SMS module (average)']
          : ['Module textos moyen'],
        priceType: 'single',
        price: 49,
        subLabel: props.lang === 'en-CA' ? 'per month' : '/mois',
      },
    },
    {
      node: {
        name: props.lang === 'en-CA' ? 'Users' : 'Utilisateurs',
        inclusions: props.lang === 'en-CA'
          ? ['7$ / user / month', 'OR 125$ unlimited']
          : ['7$ / utilisateur / mois', 'OU 125$ illimité'],
        priceType: 'dual',
        priceUser: 7,
        priceUnlimited: 125,
      },
    },
  ];

  const renderPlans = () => {
    return features.map((plan, index) => (
      <Plan lang={props.lang} plan={plan} index={index} key={index} />
    ));
  };

  return (
    <section>
      <Container>
        <h2>Une tarification qui s’adapte à vos besoins</h2>
        <Grid className={classes.plans} container direction="column" spacing={1}>
          {renderPlans()}
        </Grid>
        <Link to={props.lang === 'en-CA' ? '/en/contact-us' : '/nous-parler'}><InnerLinkButton text={props.lang === 'en-CA' ? 'Ask for a demo' : 'Demandez une démo'} /></Link>
      </Container>
    </section>
  );
};

export default Pricing;
